<script>
	import Button from "../../components/Button.svelte";
</script>

<section class="section advantages">
	<div class="container">
		<div class="advantages__column">
			<h2 class="h1 section__title b">With the Loder system, trucking companies can be more effective and efficient than ever before</h2>
			<p class="h5 section__subtitle">This platform is the best truck dispatching software available for minimizing tedious data entry tasks and automating the postings that move trucking companies forward.</p>
			<Button label='Sign up' width='150px' class='advantages__button'/>
		</div>
		<div class="advantages__grid">
			<div class="advantages-item advantages-item--1">
				<img src="../assets/svg/advantages-1.svg" alt="SVG" class="advantages-item__img">
				<p class="advantages-item__text h5 tac">
					Thanks to the software automations and database of stored information, one dispatcher can manage more runs than would be possible manually.
				</p>
			</div>
			<div class="advantages-item advantages-item--2">
				<img src="../assets/svg/advantages-2.svg" alt="SVG" class="advantages-item__img">
				<p class="advantages-item__text h5 tac">
					The Loder system saves dispatchers stress and hassle and optimizes workflow by keeping all necessary information in one intuitive platform.
				</p>
			</div>
			<div class="advantages-item advantages-item--3">
				<img src="../assets/svg/advantages-3.svg" alt="SVG" class="advantages-item__img">
				<p class="advantages-item__text h5 tac">
					Loder’s software and platform is easy for anyone to navigate and highly customizable to the user’s desired format.
				</p>
			</div>
			<div class="advantages-item advantages-item--4">
				<img src="../assets/svg/advantages-4.svg" alt="SVG" class="advantages-item__img">
				<p class="advantages-item__text h5 tac">
					By automating available tasks, Loder minimizes the risk of human error and reduces human hours necessary to successfully run a trucking company.
				</p>
			</div>
		</div>
	</div>
</section>

<style>
	.advantages {
		background: var(--system-background-secondary);
	}
	.advantages > .container {
		display: flex;
		flex-direction: row;
		gap: 30px;
		justify-content: space-between;
	}
	.advantages__column {
		max-width: 543px;
		width: 100%;
	}
	.section {
		padding: 150px 0;
	}
	.section__title {
		margin: 0;
	}
	.section__subtitle {
		max-width: 540px;
		width: 100%;
		margin: 35px 0;
		color: var(--text-color-tertiary);
	}
	.tac {
		text-align: center;
	}
	.container {
		max-width: 1320px;
		width: 100%;
		margin: 0 auto;
		padding: 0px 10px;
	}
	.advantages__grid {
		display: grid;
		grid-template-columns: repeat(2, 290px);
		grid-template-rows: 80px 260px 80px 260px 80px;
		max-width: 590px;
		grid-template-areas: 'one a' 'one two' 'three two' 'three four' 'b four';
		gap: 10px;
	}
	.advantages-item {
		background-color: var(--color-secondary-500);
		border-radius: 10px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}
	.advantages-item__img {
		margin: 0 auto 25px;
	}
	.advantages-item__text {
		max-width: 236px;
		margin: 0 auto;
		color: var(--text-color-white);
	}
	.advantages-item--1 {
		grid-area: one;
	}
	.advantages-item--2 {
		background-color: var(--color-primary-500);
		grid-area: two;
	}
	.advantages-item--3 {
		grid-area: three;
	}
	.advantages-item--4 {
		grid-area: four;
	}
	@media(max-width: 1200px) {
		.container {
			max-width: 940px;
		}
		.section {
			padding: 120px 0;
		}
		.section__title {
			font-size: 32px;
			line-height: 40px;
		}
		.section__subtitle {
			margin: 25px auto;
		}
		.advantages__grid {
			gap: 20px;
			grid-template-columns: repeat(2, 240px);
			grid-template-rows: 0px 270px 0px 270px 0;
		}
		.advantages-item__text {
			font-size: 16px;
			line-height: 20px;
			max-width: 200px;
		}
	}
	@media(max-width: 960px) {
		.container {
			max-width: 620px;
		}
		.advantages > .container {
			flex-direction: column;
			gap: 60px;
			align-items: center;
		}
		.section__title {
			text-align: center;
		}
		.section__subtitle {
			text-align: center;
		}
		:global(.advantages__button) {
			display: block;
			margin: 0 auto;
		}
	}
	@media(max-width: 640px) {
		.container {
			max-width: 460px;
		}
		.section__title {
			font-size: 24px;
			line-height: 30px;
		}
		.section__subtitle {
			margin: 20px auto;
			font-size: 14px;
			line-height: 17px;
		}
		.section {
			padding: 100px 0;
		}
		.advantages__grid {
			grid-template-columns: 220px 220px;
		}
		.advantages-item__text {
			font-size: 14px;
			line-height: 17px;
			max-width: 170px;
		}
		.advantages > .container {
			gap: 50px;
		}
	}
	@media(max-width: 480px) {
		.section__title {
			max-width: 285px;
			margin: 0 auto;
		}
		.container {
			max-width: 300px;
		}
		.section {
			padding: 70px 0;
		}
		.advantages__grid {
			grid-template-columns: 300px;
			grid-template-rows: 230px 230px 230px 230px;
			grid-template-areas: 'one''two''three''four';
		}
		.advantages-item__text {
			max-width: 230px;
		}
	}
</style>